module.exports = __webpack_public_path__ + "img/bathrobe.486be84e.png";